var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configData
    ? _c("div", { staticClass: "select-word borderPadding" }, [
        _c("div", { staticClass: "c_row-item" }, [
          _c("div", { staticClass: "c_label labelwidth" }, [
            _vm._v(" " + _vm._s(_vm.configData.title) + " "),
          ]),
          _c(
            "div",
            { staticClass: "slider-box ml22" },
            [
              _vm._l(_vm.configData.list, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "inputs" },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          size: "small",
                          maxlength: "10",
                          placeholder: "选填，不超过十个字",
                        },
                        model: {
                          value: item.val,
                          callback: function ($$v) {
                            _vm.$set(item, "val", $$v)
                          },
                          expression: "item.val",
                        },
                      },
                      [
                        index > 1
                          ? _c("i", {
                              staticClass: "el-icon-delete",
                              attrs: { slot: "suffix" },
                              on: {
                                click: function ($event) {
                                  return _vm.bindDelete(index)
                                },
                              },
                              slot: "suffix",
                            })
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _c(
                "div",
                {
                  staticClass: "button acea-row row-between-wrapper",
                  class: _vm.configData.list.length == 0 ? "on" : "",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "bnt acea-row row-center-wrapper",
                      on: { click: _vm.addHotTxt },
                    },
                    [
                      _c("span", { staticClass: "iconfont iconjia" }),
                      _vm._v(" 添加单个选项 "),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "bnt acea-row row-center-wrapper",
                      on: {
                        click: function ($event) {
                          _vm.visible = true
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "iconfont iconjia" }),
                      _vm._v(" 批量添加选项 "),
                    ]
                  ),
                  _vm.visible
                    ? _c("div", { staticClass: "batchCount" }, [
                        _c(
                          "div",
                          { staticClass: "batchItem on" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("批量添加选项"),
                            ]),
                            _c("div", { staticClass: "tips" }, [
                              _vm._v("可按回车键添加多个选项"),
                            ]),
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                autosize: { minRows: 3, maxRows: 5 },
                              },
                              model: {
                                value: _vm.batchWord,
                                callback: function ($$v) {
                                  _vm.batchWord = $$v
                                },
                                expression: "batchWord",
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "batchBnt acea-row row-right" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.cancel(1)
                                      },
                                    },
                                  },
                                  [_vm._v("取消")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml10",
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.cancel(2)
                                      },
                                    },
                                  },
                                  [_vm._v("确定")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }